import { usersEndpointIds } from 'root/src/shared/users/users.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const getApplicationStateEndpoint = {
    [usersEndpointIds.GET_APPLICATION_STATE]: {
        authentication: authenticationTypes.authenticated,
        endpointType: otherEndpointType,
    },
};
